import { Component } from '@angular/core';

@Component({
    selector: 'ui-typography',
    templateUrl: './typography.component.html',
    styleUrls: ['./typography.component.scss'],
    standalone: false
})
export class TypographyComponent {}
